// import React from 'react'
// import './sec2.css';
// import ourjourney from '../../assets/ourjourney.JPG';
// import CCE from '../../assets/CCE-logo.svg';
// import CODe from '../../assets/CODe-logo.svg';


// const Sec2 = () => {
//   return (
//     <div>
//       <div className="our-journey">
//         <div className="our-journey-img-container">
//             <img class="our-journey-img" src={ourjourney}/>
//         </div>
//         <div className="our-journey-description">
//             <h1 style={{color:"#183883", margin:"0 0 20px 0", lineHeight: 1}}>Our Journey</h1>
//             <p style={{fontSize: "larger", textAlign: "justify"}}>
//             Computer Society of India Student Chapter at the Christ College of Engineering, Irinjalakuda was established on March 4th, 2020 Inaugurated by the Kerala state student coordinator Dr. M V Rajesh. CSI CCE is an open forum that helps students through various programs like quizzes, talks, discussions, workshops, and other events. Our mission is to facilitate research, learning, and career enhancement for all categories of IT professionals. We strive to provide high quality knowledge through our workshops.</p>
//         </div>
//       </div>
//       <div className="supporting-organizations">
//         <h1 style={{textAlign: "center"}}>Our Sponsors</h1>
//         <div className="supporting-organizations-logos">
//           <a href="https://cce.edu.in" target='_blank'>
//             <img src={CCE} alt=""/>
//           </a>
//           <a href="https://cce.edu.in/department/associations/1" target='_blank'>
//             <img src={CODe} alt=""/>
//           </a>
//         </div>
//       </div>
//     </div>
//   )
// }

// export default Sec2

import React from 'react';
import './sec2.css';
import ourjourney from '../../assets/ourjourney.JPG';
import bwaffle from '../../assets/bwaffle.png';
import corizo from '../../assets/corizo.png';
import toi from '../../assets/toi.png';
import yhills from '../../assets/yhills.png';
import unibic from '../../assets/unibic.png';
import { motion, setDragLock, transform } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const Sec2 = () => {
  const { ref, inView } = useInView({
    triggerOnce: false, 
    threshold: 0.2,    
  });

  const textVariant = {
    hidden: { opacity: 0, y: 90},
    visible: { opacity: 1, y: 0, transition: { duration: 0.9 } }
  };
  const imageIn = {
    hidden: {opacity:0, x: -90},
    visible: {opacity:1, x:0, transition:{duration: 0.9}}
  }
  const textIn = {
    hidden: {opacity:0, x: 90},
    visible: {opacity:1, x:0, transition:{duration: 0.9}}
  }

  return (
    <div>
      <motion.div 
        className="our-journey"
        ref={ref}
        initial="hidden"
        animate={inView ? 'visible' : 'hidden'}
        variants={textVariant}
      >
        <motion.div 
          className="our-journey-img-container"
          ref={ref}
          initial="hidden"
          animate={inView ? 'visible' : 'hidden'}
          variants={imageIn}>
          <img className="our-journey-img" src={ourjourney} alt="Our Journey"/>
        </motion.div>
        <motion.div 
          className="our-journey-description"
          ref={ref}
          initial="hidden"
          animate={inView ? 'visible' : 'hidden'}
          variants={textIn}
          >
          <h1 style={{color:"#D2042D", margin:"0 0 20px 0", lineHeight: 1, fontSize:"3rem", fontWeight:"600"}}>Our Journey</h1>
          <p style={{fontSize: "larger", textAlign: "justify"}}>
          QuizInc, the quiz club of NIT Durgapur, was founded in 2003 by two undergraduate students Harish Mohan and Anup Nair. It is an open platform fostering curiosity, intellectual growth, and social responsibility.

With a legacy spanning over two decades, QuizInc organizes quizzes, treasure hunts, and fandom competitions while collaborating with renowned institutions across India. The club also conducts outreach programs to inspire learning beyond the campus.

QuizInc remains committed to empowering students through knowledge, critical thinking, and a shared purpose of curiosity, service, and collaboration.
          </p>
        </motion.div>
      </motion.div>

      <div className="supporting-organizations">
        <h1 style={{textAlign: "center" , fontSize:"3rem", fontWeight:"600"}}>Our Sponsors</h1>
        <div className="supporting-organizations-logos">
          <img src={bwaffle} alt="Belgian Waffle logo"/>
          <img src={corizo} alt="Corizo logo"/>
          <img src={toi} alt="TOI logo"/>
          <img src={yhills} alt="Yhills logo"/>
          <img src={unibic} alt="Unibic logo"/>
        </div>
      </div>
    </div>
  );
}

export default Sec2;